import { Injectable } from '@angular/core';

import { MatIconRegistry } from '@angular/material/icon';

import { DomSanitizer } from '@angular/platform-browser';

/**
 * Service create Icon SVG
 */
@Injectable({
  providedIn: 'root',
})
export class IconService {
  private listicon = [
    ['filter_icon', 'assets/img/filter.svg'],
    ['112', 'assets/img/flag/it.svg'],
    ['10', 'assets/img/flag/ar.svg'],
    ['17', 'assets/img/flag/bh.svg'],
    ['29', 'assets/img/flag/br.svg'],
    ['36', 'assets/img/flag/ca.svg'],
    ['64', 'assets/img/flag/fi.svg'],
    ['229', 'assets/img/flag/hu.svg'],
    ['138', 'assets/img/flag/mu.svg'],
    ['140', 'assets/img/flag/mx.svg'],
    ['154', 'assets/img/flag/no.svg'],
    ['164', 'assets/img/flag/pe.svg'],
    ['199', 'assets/img/flag/es.svg'],
    ['230', 'assets/img/flag/uy.svg'],
    ['242', 'assets/img/flag/en.svg'],
    ['171', 'assets/img/flag/en.svg'],
    ['241', 'assets/img/flag/en.svg'],
    ['243', 'assets/img/flag/en.svg'],
    ['65', 'assets/img/flag/fr.svg'],
    ['202', 'assets/img/flag/us.svg'],
    ['203', 'assets/img/flag/za.svg'],
    ['90', 'assets/img/flag/in.svg'],
    ['55', 'assets/img/flag/ie.svg'],
    ['999', 'assets/img/flag/wl.svg'],
    ['69', 'assets/img/flag/dh.svg'],
    ['13', 'assets/img/flag/au.svg'],
    ['57', 'assets/img/flag/uae.svg'],
    ['51', 'assets/img/flag/denmark.svg'],
    ['156', 'assets/img/flag/nz.svg'],
    ['161', 'assets/img/flag/pa.svg'],
    ['208', 'assets/img/flag/sweden.svg'],
    ['194', 'assets/img/flag/sg.svg'],
    ['9', 'assets/img/flag/sa.svg'],
    ['135', 'assets/img/flag/ma.svg'],
    ['132', 'assets/img/flag/my.svg'],
    ['167', 'assets/img/flag/pl.svg'],
    ['224', 'assets/img/flag/tr.svg'],
    ['225', 'assets/img/flag/tr.svg'],
    ['STATISTIC', 'assets/img/bars.svg'],
    ['FERRI-A', 'assets/img/ferri-A.svg'],
    ['FERRI-E', 'assets/img/ferri-E.svg'],
    ['FERRI-N', 'assets/img/ferri-N.svg'],
    ['FERRI-P', 'assets/img/ferri-P.svg'],
    ['0', 'assets/img/flag/horse.svg'],
    ['46', 'assets/img/flag/kr.svg'],
    ['39', 'assets/img/flag/cl.svg'],
    ['GH', 'assets/img/cani.svg'],
    ['GL', 'assets/img/galoppo.svg'],
    ['TR', 'assets/img/trotto.svg'],
    ['TG', 'assets/img/galoppo.svg'],
    ['CART', 'assets/img/cart.svg'],
    ['DETAILS', 'assets/img/details.svg'],
    ['BLIKERS', 'assets/img/tackle/blinkers.svg'],
    ['MENU-SKS', 'assets/img/sks/list-ul.svg'],
    ['DETAILS-SKS', 'assets/img/sks/betslip-alt.svg'],
    ['TICKETS-SKS', 'assets/img/sks/ticket.svg'],
    ['STATS-EUROBET', 'assets/img/eurobet/chart-bar-alt.svg'],
  ];

  /**
   * Constructor service, create all icons used in website
   * @param matIconRegistry Service to register and display icons used by the <mat-icon> component.
   * @param domSanitizer DomSanitizer helps preventing Cross Site
   * Scripting Security bugs (XSS) by sanitizing values to be safe to use in the different DOM contexts.
   */
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
    this.listicon.forEach((ele) => {
    this.matIconRegistry.addSvgIcon(
        ele[0],
        this.domSanitizer.bypassSecurityTrustResourceUrl(ele[1])
    );
    });
  }
}
